<template>
  <div class="dialog">
    <el-dialog
      title="推送提醒"
      @close="closeView"
      :visible.sync="remindViewbtns"
      width="35%"
      :modal-append-to-body="false"
    >
      <div class="pushBody">
        <div class="pushTips">满足以下条件的学员自动进入续费提醒列表。</div>
        <div class="pushTips">
          如果开启自动推送，则在规定时间内推送消息告知学员。
        </div>
        <div class="form-wrap">
          <el-form
            size="mini"
            :model="form"
            :rules="rules"
            label-width="80px"
            ref="mainForm"
          >
            <el-form-item label="自动推送:" prop="renew_auto_switch">
              <el-switch
                class="no-off"
                v-model="form.renew_auto_switch"
              ></el-switch>
            </el-form-item>
            <el-form-item label="推送时间:" prop="renew_push_time">
              <div class="time-wrap">
                <el-time-select
                  style="width: 110px; margin: 0 10px"
                  v-model="form.renew_push_time"
                  :picker-options="{
                    start: '00:00',
                    step: '01:00',
                    end: '23:00',
                  }"
                  placeholder="选择时间"
                >
                </el-time-select>
              </div>
            </el-form-item>
            <el-form-item label="课时条件:">
              <div class="lesson-wrap">
                <el-radio-group v-model="form.renew_type">
                  <el-radio-button :label="2">按总课时</el-radio-button>
                  <el-radio-button :label="3">按类型</el-radio-button>
                  <el-radio-button :label="1">按课程</el-radio-button>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item label="">
              <div style="display: flex">
                <span v-if="form.renew_type === 2">所有课程总剩余课时数≤</span>
                <span v-if="form.renew_type === 3"
                  >1v1或1vN类型下的课程总剩余课时数≤</span
                >
                <span v-if="form.renew_type === 1">单个课程剩余课时数≤</span>
                <el-input
                  style="width: 90px; margin-left: 12px"
                  v-model.number="form.renew_lesson_count"
                  @input="(e) => (form.renew_lesson_count = isnumber(e))"
                  placeholder="请输入正整数"
                  type="number"
                ></el-input>
                <span style="margin-left: 10px">课时</span>
              </div>
            </el-form-item>
            <el-form-item label="排除课程:" prop="">
              <div class="course-select-input">
                <common-course-selector
                  class="selector"
                  :origin-list="form.exclude_course_list"
                  @change="
                    (arr) => {
                      form.exclude_course_list = arr;
                    }
                  "
                >
                  <span
                    class="no-data"
                    v-show="form.exclude_course_list.length === 0"
                    >请选择</span
                  >
                  <span class="title">{{
                    form.exclude_course_list
                      .map((course) => {
                        return course.title;
                      })
                      .join("、")
                  }}</span>
                </common-course-selector>
                <span
                  class="clear el-icon-error"
                  v-if="form.exclude_course_list.length > 0"
                  @click="
                    () => {
                      form.exclude_course_list = [];
                    }
                  "
                ></span>
              </div>
            </el-form-item>
          </el-form>
          <div class="pushTips yellow">排除的课程不计入续费提醒业务，</div>
          <div class="pushTips yellow">
            续费后如果大于设定的提醒课时数，则不在列表显示，
          </div>
          <div class="pushTips yellow">
            且需要教务人员，在点名签到模块主动完成超上课时的补扣。
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="mwow-button-filled mini" @click="closeView">取消</div>
        <div class="mwow-button-filled mini success" @click="keepClick">
          保存
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { renewSet } from "@/api/renewal";
import { switchDetailApi } from "@/api/storeManagement";
import commonCourseSelector from "@/components/commonCourseSelector.vue";
export default {
  components: {
    commonCourseSelector,
  },
  data() {
    return {
      remindViewbtns: true,
      form: {
        renew_push_time: "",
        renew_auto_switch: false,
        renew_lesson_count: "",
        renew_type: 2,
        exclude_course_ids: [],
        exclude_course_list: [],
      },
      rules: {
        renew_push_time: [
          { required: true, message: "请选择推送时间", trigger: "change" },
        ],
        renew_auto_switch: [{ required: true }],
        renew_lesson_count: [{ required: true, message: "请输入剩余课时" }],
      },
    };
  },
  props: ["time", "switch", "lessonCount", "renewType", "excludeCourse"],
  created() {
    this.form.renew_push_time = this.time.slice(0, 5);
    this.form.renew_auto_switch = this.switch == 1 ? true : false;
    this.form.renew_lesson_count = this.lessonCount;
    this.form.renew_type = this.renewType;
    this.form.exclude_course_list = this.excludeCourse;
    this.form.exclude_course_ids = this.excludeCourse.map((c) => {
      return c.course_id;
    });
  },
  methods: {
    isnumber(val) {
      val = val.replace(/[^0-9]/gi, "");
      // 此处还可以限制位数以及大小
      if (val.length > 5) {
        return Number(val.slice(0, 5));
      }
      return Number(val);
    },
    closeView() {
      this.$emit("closeView", "close");
    },
    keepClick() {
      const _t = this;
      const data = {
        renew_auto_switch: this.form.renew_auto_switch == true ? 1 : 2,
        renew_push_time: this.form.renew_push_time + ":00",
        renew_lesson_count: Number(this.form.renew_lesson_count),
        renew_type: Number(this.form.renew_type),
        course_ids: this.form.exclude_course_list.map((c) => {
          return c.course_id;
        }),
      };
      _t.$refs["mainForm"].validate((valid) => {
        if (valid) {
          renewSet(data).then((res) => {
            this.$message({
              type: "success",
              message: "设置完毕!",
            });
            this.$emit("closeView", "keep");
            // 获取门店配置开关详情存储到localStorage
            switchDetailApi().then((res) => {
              if (res.error_code === 0) {
                const switchDetail = {
                  free_courses: false,
                  student_superupper: false,
                  automatic_make_up: false,
                  renew_auto_switch: false,
                  renew_lesson_count: 5,
                  renew_push_time: "09:00",
                  new_buy_renew_time: 30,
                };
                switchDetail.free_courses = res.data.free_arrange_lesson === 1;
                switchDetail.student_superupper = res.data.student_exceed === 1;
                switchDetail.automatic_make_up =
                  res.data.student_exceed_automatic_sub === 1;
                switchDetail.renew_auto_switch =
                  res.data.renew_auto_switch === 1;
                switchDetail.renew_lesson_count = res.data.renew_lesson_count;
                switchDetail.renew_push_time = res.data.renew_push_time;
                switchDetail.new_buy_renew_time = res.data.new_buy_renew_time;
                localStorage.setItem(
                  "switch_type",
                  JSON.stringify(switchDetail)
                );
              }
            });
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.pushTips {
  color: #9e9fa0;
  font-size: 12px;
  line-height: 20px;
}
.pushinfo {
  display: flex;
  margin-top: 14px;
  .pushHead {
    color: #5c5d5e;
    font-size: 12px;
    font-weight: 500;
    width: 70px;
  }
  .infodata {
    color: #5c5d5e;
    font-size: 12px;
    div {
      margin-bottom: 5px;
    }
  }
  .infodata.list {
    display: flex;
    flex-wrap: wrap;
  }
}
.time-wrap {
  .el-input {
    margin: 0 !important;
    width: 230px !important;
  }
}
.lesson-wrap {
  .el-input {
  }
  span {
    margin-left: 10px;
    color: #ffb940;
  }
}
.yellow {
  color: #ffb940;
}
.no-off {
  margin-top: 5px;
}
.course-select-input {
  height: 28px;
  text-overflow: ellipsis;
  padding: 0 25px 0 15px;
  color: #5c5d5e;
  font-size: 12px;
  border: 1px solid #e7e8ea;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  &:hover {
    .clear {
      display: block;
    }
  }
  .selector {
    flex: 1;
    width: 0;
    overflow: hidden;
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      display: block;
    }
    .no-data {
    }
  }
  .clear {
    position: absolute;
    top: 7px;
    right: 5px;
    display: none;
    color: #c0c4cc;
    font-size: 14px;
  }
}
</style>
